import type { CSSProperties } from 'react';
import React, { FC } from "react";
import { AssociationType } from "../../../types";
import { AssociationDroppableItem } from "./AssociationDroppableItem";
import { DroppableListContainer } from "components/DroppableListContainer";

type Props = {
  title: string,
  associations: AssociationType[],
  droppableContainerId: string,
  height?: CSSProperties["height"],
}

export const DroppableList: FC<Props> = ({ title, associations, droppableContainerId, height }) => {
  return (
    <DroppableListContainer title={title} items={associations} droppableContainerId={droppableContainerId} height={height}>
      {associations.map(item => (
        <AssociationDroppableItem association={item} containerId={droppableContainerId} />
      ))}
    </DroppableListContainer>
  );
};
